let apiURL = "https://www.sundialhome.com/api/";

const currentEnv = (typeof import.meta !== 'undefined' && import.meta.env) 
  ? import.meta.env.REACT_APP_ENVIRONMENT  || import.meta.env.REACT_APP_ENVIROMENT
  : (typeof process !== 'undefined' ? process.env.REACT_APP_ENVIRONMENT || process.env.REACT_APP_ENVIROMENT : undefined);

const isDev = currentEnv === "DEV";

if (isDev) {
  //tahir's ip
  // apiURL = "http://192.168.100.14:3001/api/";
  // qa Url
  apiURL = "https://qa.sundialhome.com/api/";
  //local Api/
  // apiURL = "https://api.sundialhome.com/api/";
  //  apiURL = "http://10.86.119.6:3001/api/";
}
apiURL = "__API_URL_PLACEHOLDER__";
export { apiURL, currentEnv, isDev };
